<template>
	<v-dialog
		v-model="showDialog"
		max-width="600px"
		@click:outside="showDialog = false"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card dense flat>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">{{ dialogTitle }}</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-sheet class="ma-2">
				<v-sheet class="ma-2">
					<div>
						<v-icon color="red" class="mr-1">mdi-alert-circle-outline</v-icon>{{ dialogContent }}
					</div>
					<!-- TODO 表形式で表記 -->
					<div style="color: red" v-for="shipping in exceededShippings" :key="shipping.id">
						製品名: {{ shipping.order_target.ordered_product.product.name }}/ 予定数量個数:
						{{ shipping.planned_quantity }}/ 出庫数: {{ shipping.actual_quantity }}
					</div>
				</v-sheet>
			</v-sheet>

			<v-card-actions>
				<v-row no-gutters justify="space-around">
					<v-btn color="secondary" @click="submit" class="mt-4">出庫を確定する</v-btn>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: {
		dialog: {
			type: Boolean,
			default: false,
		},
		dialogTitle: {
			type: String,
			default: "",
		},
		dialogContent: {
			type: String,
			default: "",
		},
		dialogContent: {
			type: String,
			default: "",
		},
		exceededShippings: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {}
	},
	methods: {
		submit() {
			this.$emit('submit')
			this.showDialog = false
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
}
</script>
